import {
  useParams,
  useSearchParams,
} from "react-router-dom"

import { hasExactIdentifier } from "@/lib/exact-search"
import type { OrdersSearchParamsType } from "@/types/orders"
import { DateHelper } from "@/utils"
const useOrdersSearchParams = () => {
  const routeParams = useParams()
  const [searchParams] = useSearchParams()
  // Sem filtro na URL, a tela abre no dia de hoje — não numa janela retroativa.
  const stringStartDate = DateHelper.currentDate()
  const stringEndDate = DateHelper.currentDate()
  const startDate = new Date(
    DateHelper.formatToISO(stringStartDate)
  )
  const endDate = new Date(
    DateHelper.formatToISO(stringEndDate)
  )
  const customerDocument =
    searchParams.get("customerDocument") || undefined
  const code = searchParams.get("code") || undefined
  const ownId = searchParams.get("ownId") || undefined

  // Busca por identificador exato NÃO ganha data padrão. Sem esta condição o filtro tirava o
  // período da URL e este hook o devolvia logo em seguida — o pedido de meses atrás continuava
  // fora do recorte, e a tela ainda mostrava a data preenchida como se fosse escolha do operador.
  const searchesByIdentifier = hasExactIdentifier({
    customerDocument,
    code,
    ownId,
  })

  /**
   * A URL já recorta por outra data (pagamento, expiração ou cancelamento).
   *
   * <p>Sem esta condição o padrão de criação era acrescentado por cima do recorte escolhido, e a
   * consulta passava a exigir que o pedido satisfizesse as DUAS datas — filtrar "pago hoje"
   * devolvia só o que também tivesse sido criado hoje. O filtro manda um par; quem lê não pode
   * inventar um segundo.</p>
   */
  const filtersAnotherDateField = [
    "paidFrom",
    "paidTo",
    "expiresFrom",
    "expiresTo",
    "canceledFrom",
    "canceledTo",
  ].some((param) => searchParams.get(param))

  const keepsCreationRangeOut =
    searchesByIdentifier || filtersAnotherDateField

  const params: OrdersSearchParamsType = {
    from:
      searchParams.get("from") ||
      (keepsCreationRangeOut ? undefined : stringStartDate),
    to:
      searchParams.get("to") ||
      (keepsCreationRangeOut ? undefined : stringEndDate),
    page: Number(searchParams.get("page")) || 0,
    pageSize: Number(searchParams.get("pageSize")) || 10,
    code,
    status: searchParams.get("status") || undefined,
    statusNot: searchParams.get("statusNot") || undefined,
    paymentMethod:
      searchParams.get("paymentMethod") || undefined,
    customerDocument,
    ownId,
    // Nenhum destes ganha padrão: sem informar, o intervalo recorta a criação.
    paidFrom: searchParams.get("paidFrom") || undefined,
    paidTo: searchParams.get("paidTo") || undefined,
    expiresFrom: searchParams.get("expiresFrom") || undefined,
    expiresTo: searchParams.get("expiresTo") || undefined,
    canceledFrom:
      searchParams.get("canceledFrom") || undefined,
    canceledTo: searchParams.get("canceledTo") || undefined,
    salesChannel:
      searchParams.get("salesChannel") || undefined,
    whiteLabelId:
      searchParams.get("whiteLabelId") || undefined,
    orderId: (routeParams.orderId as string) || undefined,
    orderCode:
      (routeParams.orderCode as string) || undefined,
    refetch: searchParams.get("refetch") || undefined,
  }
  return {
    params,
    startDate,
    endDate,
  }
}
export default useOrdersSearchParams
